import { render, staticRenderFns } from "./Mar202011.vue?vue&type=template&id=01a981a8&scoped=true"
import script from "./Mar202011.vue?vue&type=script&lang=js"
export * from "./Mar202011.vue?vue&type=script&lang=js"
import style0 from "./Mar202011.vue?vue&type=style&index=0&id=01a981a8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a981a8",
  null
  
)

export default component.exports